import { Component, Input, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { Router } from '@angular/router'
import { Selvityspyynto } from '@lemon/core-firebase/model/selvitettavat'
import { FirestoreTosite, FirestoreTositteenKuva } from '@lemon/core-firebase/model/tosite'
import { TositeUriService } from '@lemon/core-firebase/service/tosite/tosite-uri.service'
import { firstValueFrom } from 'rxjs'
import { take } from 'rxjs/operators'
import { FirebaseLemonaid } from '../../../_angular/service/firebase-lemonator.service'
import { LEMONATOR_HTTPS_IMAGES_API } from '../../../_angular/service/lemon-http.service'
import { Asiakas } from '../../../_jaettu-lemonator/model/asiakas'

@Component({
  selector: 'app-tosite-selvitys-kortti',
  templateUrl: './tosite-selvitys-kortti.component.html',
  styleUrls: ['./tosite-selvitys-kortti.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TositeSelvitysKorttiComponent implements OnInit {
  @Input() kortti: Selvityspyynto
  @Input() asiakas: Asiakas

  readonly esikatselukuvaUrl = signal<string | null>(null)

  constructor(
    private _firebaseLemonaid: FirebaseLemonaid,
    private _tositeUriService: TositeUriService,
    private _router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    const tositeAvain = this.kortti.tositeAvaimet?.[0]
    if (!tositeAvain || !this.asiakas) {
      return
    }
    const tositeUri = this._tositeUriService.annaTositteenFirestoreUri(this.asiakas.avain, tositeAvain)
    const tosite = await firstValueFrom(this._firebaseLemonaid.firestoreDoc<FirestoreTosite>(tositeUri).listen().pipe(take(1)))
    if (!tosite) {
      return
    }
    this.esikatselukuvaUrl.set(this._annaEsikatselukuvanUrl(tosite))
  }

  get tositeAvain(): string | null {
    return this.kortti.tositeAvaimet?.[0] ?? null
  }

  avaaTosite() {
    if (!this.tositeAvain || !this.asiakas) {
      return
    }
    this._router.navigate(['asiakkaat', this.asiakas.avain, 'tositteet', 'selaa', this.tositeAvain])
  }

  private _annaEsikatselukuvanUrl(tosite: FirestoreTosite): string | null {
    let kuva: FirestoreTositteenKuva = null
    for (const kuvanAvain of Object.keys(tosite.kuvat || {})) {
      const mahdollinen = tosite.kuvat[kuvanAvain]
      if (!mahdollinen.poistettu && (kuva === null || mahdollinen.jarjestys < kuva.jarjestys)) {
        kuva = mahdollinen
      }
    }
    if (!kuva) {
      return null
    }
    const kuvanUrl = this._tositeUriService.annaCloudStorageKuvaUri(this.asiakas.asiakasId + '', tosite.kuvakansio, kuva.avain + '_thumb', 'webp')
    return LEMONATOR_HTTPS_IMAGES_API + '/api/1/kuvat/' + kuvanUrl
  }
}
